import React, { FunctionComponent } from 'react';

import { Card } from 'components';
import { Heading, Icon, Text } from 'components/chroma';

import { toAussieStandardDateFormat } from 'scenes/common/helpers/datetime';

import { PolicyHolder } from 'scenes/motor/types';

export const PersonalContactCard: FunctionComponent<{
  policyHolder: PolicyHolder;
  selected: boolean;
  onClick: () => void;
}> = ({ policyHolder, selected, onClick }) => (
  <Card
    id={policyHolder.firstName}
    selected={selected}
    center
    onClick={onClick}
    role="button"
  >
    <Icon name="checkCircle" margin={{ right: 5 }} />
    <div>
      <Heading size={4} margin={{ bottom: 0 }}>
        {policyHolder.firstName}&nbsp;{policyHolder.lastName}
      </Heading>
      <Text>{`${policyHolder.gender} - ${toAussieStandardDateFormat(
        policyHolder.dob
      )}`}</Text>
    </div>
  </Card>
);
